<template>
  <login>
    <form>
      <div class="auth-text">
        <h3>به هنزاگلد خوش آمدید</h3>
        <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</p> -->
      </div>
      <!--start send phone -->
      <div>
        <div class="form-group">
          <input v-model="Fname"
                 type="text" class="form-control form-control-light" placeholder="نام">
        </div>
        <div v-if="Alert[0]  && !Fname"
             class="text-danger text-sm" style="margin-right: .5rem;">
          {{ Alert[0] }}
        </div>
        <div class="form-group">
          <input v-model="Lname"
                 type="text" class="form-control form-control-light" placeholder="نام خانوادگی">
        </div>
        <div v-if="Alert[1] && !Lname"
             class="text-danger text-sm" style="margin-right: .5rem;">
          {{ Alert[1] }}
        </div>
        <div class="form-group">
          <input v-model="Phone"
                 type="text" class="form-control form-control-light" placeholder="شماره تلفن همراه">
        </div>
        <div v-if="Alert[2] && !Is_Phone_Correct"
             class="text-danger text-sm" style="margin-right: .5rem;">
          {{ Alert[2] }}
        </div>
        <button @click.prevent="Register"
                class="btn-custom secondary btn-block">ثبت نام
        </button>
        <!--                <div class="auth-seperator">-->
        <!--                    <span></span>-->
        <!--                </div>-->
      </div>
      <!--end send phone -->
      <div class="social-login">
        <a href="https://henzagold.shop/" class="btn-custom secondary btn-block">
          بازگشت به فروشگاه
        </a>
      </div>
      <p class="text-center mb-0">آیا حساب کاربری دارید ؟
        <router-link to="/login" class="">ورود</router-link>
      </p>
    </form>
  </login>
</template>

<script>
import router from '@/router'
import axios from '@/plugins/axios'
import login from '@/components/layouts/login'

export default {
  props: {
    togglePreLoader: Function
  },
  components: {
    login
  },
  data() {
    return {
      Fname: null,
      Lname: null,
      Phone: null,
      Alert: [null, null, null],
      Is_Phone_Correct: true
    }
  },
  methods: {
    async Register() {
      try {
        if (/^(\+98|0098|98|0)?9\d{9}$/g.test(this.Phone) && this.Fname && this.Lname) {
          this.togglePreLoader('open')
          await axios({
            method: 'post',
            url: `/cu/register`,
            headers: {},
            data: {
              phone: this.Phone,
              lname: this.Lname,
              fname: this.Fname
            }
          })
          router.push('/customer/login')
        } else {
          if (!this.Fname) {
            this.$vs.notify({
              time: 3500,
              text: 'نام را وارد نمایید',
              color: 'var(--secondary-color)',
              icon: 'error_outline'
            })
          }
          if (!this.Lname) {
            this.$vs.notify({
              time: 3500,
              text: 'نام خانوادگی را وارد نمایید',
              color: 'var(--secondary-color)',
              icon: 'error_outline'
            })
          }
          if (!/^(\+98|0098|98|0)?9\d{9}$/g.test(this.Phone)) {
            this.$vs.notify({
              time: 3500,
              text: 'شماره تلفن همراه را وارد نمایید',
              color: 'var(--secondary-color)',
              icon: 'error_outline'
            })
          }
        }
      } catch (error) {
        // debugger
        console.log(error.response)
        if (error.response.data) {
          let str_error = ''
          for (let x of Object.values(error.response.data.errors)) {
            x.map(xx => {
              str_error += xx + "<br/>"
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
  },
  mounted() {
  },
  watch: {
    Phone() {
      if (this.Phone) {
        if (/^(\+98|0098|98|0)?9\d{9}$/g.test(this.Phone) !== true) {
          this.Alert[2] = 'تلفن همراه وارد شده نامعتبر می باشد'
          this.Is_Phone_Correct = false
        } else {
          this.Alert[2] = null
          this.Is_Phone_Correct = true
        }
      } else {
        this.Alert[2] = 'وارد کردن تلفن همراه الزامی است'
        this.Is_Phone_Correct = false
      }
    },
    Fname() {
      if (this.Fname) {
        if (/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/.test(this.Fname) !== true) {
          this.Alert[0] = 'نام باید تنها شامل حروف فارسی باشد'
        } else {
          this.Alert[0] = null
        }
      } else {
        this.Alert[0] = 'وارد کردن نام الزامی است'
      }
    },
    Lname() {
      if (this.Lname) {
        if (!/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/.test(this.Lname)) {
          this.Alert[1] = 'نام باید تنها شامل حروف فارسی باشد'
        } else {
          this.Alert[1] = null
        }
      } else {
        this.Alert[1] = 'وارد کردن نام خانوادگی الزامی است'
      }
    }
  }
}
</script>
